import { connect } from "react-redux";

import * as selectors from "../selectors";
import * as actions from "../actions";
import { getEnvSetting } from "../utils/env";
import App from "../components/App";

const mapStateToProps = (state, props) => {
  const activeInstitution = selectors.getInstitution(
    state,
    selectors.getActiveInstitution(state)
  );

  return {
    isFixedHeight: props.location.pathname === "/map",
    token: selectors.getToken(state),
    navIsOpen: selectors.navIsOpen(state),
    user: selectors.getUser(state),
    isLoadingUser: selectors.isLoadingUser(state),
    isLoadingDistricts: selectors.isLoadingDistricts(state),
    isLoadingCategories: selectors.isLoadingCategories(state),
    isInitializing: selectors.isInitializing(state),
    area: activeInstitution
      ? selectors.getArea(state, activeInstitution.area)
      : {},
    activeInstitution,
    categories: selectors.getCategories(state),
    districts: selectors.getDistricts(state),
    appTitle: getEnvSetting("REACT_APP_TITLE")
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadUser: () => dispatch(actions.fetchUser()),
    onToggleNav: () => dispatch(actions.toggleNav())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



/** WEBPACK FOOTER **
 ** ./src/containers/AppContainer.js
 **/